import { z } from 'zod';
import { paginationInput, sortInput, idInput } from './common';
import { userProfileEnum } from './auth';

export const listUsersInput = paginationInput.merge(sortInput).extend({
  search: z.string().optional(),
  permissao: userProfileEnum.optional(),
  ativo: z.boolean().optional(),
});

export const createUserInput = z.object({
  nome: z.string().min(2, 'Nome deve ter no minimo 2 caracteres'),
  email: z.string().email('Email invalido'),
  senha: z.string().min(6, 'Senha deve ter no minimo 6 caracteres'),
  cargoIds: z.array(z.string().uuid()).default([]),
});

export const updateUserInput = idInput.extend({
  nome: z.string().min(2).optional(),
  email: z.string().email().optional(),
  ativo: z.boolean().optional(),
  cargoIds: z.array(z.string().uuid()).optional(),
});

export const userOutput = z.object({
  id: z.string(),
  nome: z.string(),
  email: z.string(),
  ativo: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ListUsersInput = z.infer<typeof listUsersInput>;
export type CreateUserInput = z.infer<typeof createUserInput>;
export type UpdateUserInput = z.infer<typeof updateUserInput>;
export type UserOutput = z.infer<typeof userOutput>;
